import { mapGetters, mapState } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import tabs from '@/components/generics/tabs/tabs.vue';
import portfolioMyMarkets from '@/components/dashboard/portfolio-my-markets/portfolio-my-markets.vue';
import accountSocialBadge from '@/components/account/account-social-badge/account-social-badge.vue';
import friendsSearch from '@/components/dashboard/friends-search/friends-search.vue';
import dashboardMarketFilters from '@/components/market/market-filters/market-filters-dashboard/market-filters-dashboard.vue';
import dashboardMarketsToggle from '@/components/dashboard/dashboard-markets-toggle/dashboard-markets-toggle.vue';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import shareInviteWidget from '@/components/social/share-invite-widget/share-invite-widget.vue';
import leaderboardsInfo from '@/components/leaderboards/leaderboards-info/leaderboards-info.vue';
import notificationsList from '@/components/notifications-list/notifications-list.vue';
import publicProfileWidget from '@/components/profile/public-profile-widget/public-profile-widget.vue';
import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';

const TAB_WEEK = 'week';
const TAB_MONTH = 'month';
// const TAB_YEAR = 'year';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
  ],
  components: {
    publicProfileWidget,
    leaderboardsInfo,
    shareInviteWidget,
    infiniteLoading,
    tabs,
    portfolioMyMarkets,
    accountSocialBadge,
    friendsSearch,
    dashboardMarketFilters,
    marketChangePrice,
    dashboardMarketsToggle,
    notificationsList,
  },
  data() {
    return {
      showTabs: true,
      activeTab: null,
      infiniteLoader: null,
      tabs: [
        {
          name: TAB_WEEK,
          title: '1 Week',
          timespan: '1w',
        },
        {
          name: TAB_MONTH,
          title: '1 Month',
          timespan: '1m',
        },
        // {
        //   name: TAB_YEAR,
        //   title: '1 Year',
        //   timespan: '1y',
        // },
      ],
    };
  },
  computed: {
    ...mapGetters('dashboard', ['mySharesTotalGainLoss']),
    ...mapGetters('wallet', ['portfolioValueDecimal']),
    ...mapState('dashboard', ['mySharesReady']),
    ...mapState('wallet', ['balance']),
    ...mapGetters('app', ['isShutdownModeOn']),
    portfolioValueReady() {
      return !this.balance.isDefault && this.mySharesReady;
    },
    activeTabTimespan() {
      return this.getActiveTabTimespan(this.activeTab);
    },
    moreRecentTradesModifiers() {
      return {
        'dashboard-desktop__trades-footer-button': true,
      };
    },
    gainLossClassModifiers() {
      const value = this.mySharesTotalGainLoss;
      return {
        'dashboard-desktop__header--plus': value > 0,
        'dashboard-desktop__header--minus': value < 0,
      };
    },
    showMyMarkets() {
      return this.$route.name === 'portfolio';
    },
    showNotifications() {
      return this.$route.name === 'notifications';
    },
    showInfo() {
      return process.env.LEADERBOARDS_ENABLED && !this.isShutdownModeOn;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard-desktop/dashboard-desktop.js